import React from 'react';
import ModalButtons from "../ModalButtons/ModalButtons";
import Tabs from '../Tabs/Tabs';
import ReservationSegmentCardPresenterWorkspace from "./ReservationSegmentCardPresenterWorkspace";

class ReservationSegmentCardPresenter extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      active_tab: 'details',
      ...this.props
    }
    this.onChangeTab = this.onChangeTab.bind(this)
  }

  render(){
     
      var buttons = [
        {
          name: I18n.t('ok'),
          html_attributes: [
            'data-dismiss="modal"'
          ]
        }  
      ]
    return (
      <div className="ReservationSegmentCard">

        <Tabs tabs={this.tabs()} />
        <div className="panel panel-form">
          <ModalButtons loading={this.state.loading} buttons={buttons} />
          <ReservationSegmentCardPresenterWorkspace {...this.state} />
        </div>
        {/* <div className="overlay">
          <div className="spinner"></div>
        </div> */}
      </div>
    );
  };

  tabs(){
    if(this.props.historical_view == true) {
      return (
        [
          {
            tabName: I18n.t('details'),
            targetName: 'details',
            classes: this.state.active_tab === 'details' ? 'active' : null,
            changeHandler: this.onChangeTab,
          },
        ]
      )
    } else {

      return (
        [
          {
            tabName: I18n.t('details'),
            targetName: 'details',
            classes: this.state.active_tab === 'details' ? 'active' : null,
            changeHandler: this.onChangeTab,
          },
          {
            tabName: I18n.t('history'),
            targetName: 'history',
            classes: this.state.active_tab === 'history' ? 'active' : null,
            changeHandler: this.onChangeTab,
          },
    
        ]
      )
    }

  };

  onChangeTab(tab) {
    this.setState({active_tab: tab});
  };




}
export default ReservationSegmentCardPresenter